/**
 * Client-only substring search over the hardcoded home search name list (no API).
 * Scans the full list each query (list size ~50k is fine with debounce in HeroSearch).
 * The dropdown only shows `limit` rows; every name can still surface for a tighter query.
 */

export function searchHeroStaticNames(names, query, options = {}) {
  const list = Array.isArray(names) ? names : [];
  const limit = options.limit ?? 14;
  const minLength = options.minLength ?? 3;

  const searchLower = (query || '').toLowerCase().trim();
  if (searchLower.length < minLength) return [];

  const starts = [];
  const contains = [];

  for (const name of list) {
    if (typeof name !== 'string' || !name.trim()) continue;
    const n = name.toLowerCase();
    if (n.startsWith(searchLower)) {
      starts.push(name);
    } else if (n.includes(searchLower)) {
      contains.push(name);
    }
  }

  starts.sort((a, b) => a.localeCompare(b));
  contains.sort((a, b) => a.localeCompare(b));

  const merged = [...starts, ...contains].slice(0, limit);
  return merged.map((name) => ({
    type: 'place',
    id: '',
    name,
    country: '',
  }));
}
